import React from 'react';
import { SunriseCard, SunsetCard } from '../SunTimeCards.js';

// Mevcut (default) görünüm: yan yana iki kart. Registry tutarlılığı için vm
// prop'unu alır ve eskisiyle birebir aynı şekilde render eder.
const KlasikDesign = ({ vm }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
    <SunriseCard time={vm.sunriseDst} district={vm.district} city={vm.city} date={vm.dateSlash} />
    <SunsetCard time={vm.sunsetDst} district={vm.district} city={vm.city} date={vm.dateSlash} />
  </div>
);

export default KlasikDesign;
